<template>
  <div class="share-wrapper">
    <div class="share-info">选择分享地址</div>
    <span class="share-items"></span>
  </div>
</template>

<script>
export default {
  name: 'Share',
  mounted () {
    /* eslint-disable */
    socialShare('.share-items', {
      sites: ['wechat', 'weibo'],
      url: window.location.href
    })
  },
}
</script>

<style scoped>
  .share-wrapper {
    width: 100%;
    height: 100%;
    padding: 200px 20px;
    text-align: center;
    color: #ffffff;
  }
</style>